/**
 * Time-based rate gate: one event per key per interval, per JS realm. Time-based rather than once-per-process
 * because instances churn; it caps the *rate*, not the total. The map is bounded: the oldest key is evicted
 * beyond `maxKeys`, so an unbounded key space (ids in a route) cannot grow it.
 */
export function createReportThrottle(intervalMs: number, maxKeys = 500) {
    const lastReportedAt = new Map<string, number>();

    return {
        shouldReport(key: string, now: number = Date.now()): boolean {
            const previous = lastReportedAt.get(key);
            if (undefined !== previous && now - previous < intervalMs) {
                return false;
            }
            // Delete first so a re-reported key moves to the end of the (insertion-ordered) map.
            lastReportedAt.delete(key);
            lastReportedAt.set(key, now);
            if (lastReportedAt.size > maxKeys) {
                lastReportedAt.delete(lastReportedAt.keys().next().value as string);
            }
            return true;
        },
        reset(): void {
            lastReportedAt.clear();
        }
    };
}
